<template>
  <div class="row">
    <input
      v-if="value.id"
      :id="'id_' + value.id"
      type="hidden"
      :value="value.id"
    >
    <div class="col-sm-4">
      <div>
        <label for="name">Nazwa</label>
        <input
          id="name"
          class="form-control"
          :value="value.label"
          @input="updateLabel($event.target.value)"
        >
      </div>
    </div>
    <div class="col-sm-4">
      <div class="form-group checkbox">
        <div class="form-checkbox">
          <input
            :id="`initial${rowIndex}`"
            v-model="value.initial"
            type="checkbox"
            @change="emitModificationSignal"
          >
          <label :for="`initial${rowIndex}`">Status początkowy</label>
        </div>
      </div>
      <div class="form-group checkbox">
        <div class="form-checkbox">
          <input
            :id="`final${rowIndex}`"
            v-model="value.final"
            type="checkbox"
            @change="emitModificationSignal"
          >
          <label :for="`final${rowIndex}`">Status końcowy</label>
        </div>
      </div>
      <div class="form-group checkbox">
        <div class="form-checkbox">
          <input
            :id="`appraisalBR${rowIndex}`"
            v-model="value.metadata['appraisalBR']"
            type="checkbox"
            @change="emitModificationSignal"
          >
          <label :for="`appraisalBR${rowIndex}`">Status BR</label>
        </div>
      </div>
    </div>
    <div class="col-sm-4">
      <div>
        <label for="assignee-type">Odpowiedzialny:</label>
        <select
          id="assignee-type"
          v-model="value.assigneeType"
          class="form-control"
          @input="updateAssigneeType($event.target.value)"
        >
          <option
            v-for="(option, index) in assigneeTypes"
            :key="index"
            :value="option.id"
          >
            {{ option.value }}
          </option>
        </select>
      </div>
      <div v-if="value.assigneeType === assigneeTypes.list.id">
        <label for="role-assignee">Role:</label>
        <select
          id="role-assignee"
          v-model="value['accessRoles']"
          class="form-control"
          multiple
        >
          <option
            v-for="(option, index) in roles"
            :key="index"
            :value="option.id"
          >
            {{ option.label }}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: Object,
    rowIndex: { type: Number, required: true },
    roles: { type: Array, required: true }
  },
  data () {
    return {
      assigneeTypes: {
        none: {
          id: 1,
          value: 'brak'
        },
        current: {
          id: 2,
          value: 'bieżący'
        },
        author: {
          id: 3,
          value: 'autor'
        },
        list: {
          id: 4,
          value: 'lista'
        }
      }
    }
  },
  methods: {
    emitModificationSignal () {
      this.$emit('modified')
    },
    updateLabel (value) {
      this.value.label = value
      this.$emit('input', this.value)
      this.emitModificationSignal()
    },
    updateAssigneeType (value) {
      if (value !== this.assigneeTypes.list.id) {
        this.value.accessRoles = []
      }
    }
  }
}
</script>

<style scoped>
.input-group {
    width: 100%;
}
</style>
